<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户换绑记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-input v-model.trim="queryField.log_id" size="small" placeholder="id"></el-input>
        <el-input v-model.trim="queryField.operate_user_id" size="small" placeholder="用户id"></el-input>
        <el-select v-model="queryField.operate_type" placeholder="变更类型">
          <el-option
              v-for="item in operateTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
      </el-row>
      
      <el-table class="cps-table-data"
                :data="tableData" size="small"
                border
                :height="height"
                style="width: 100%">
        <el-table-column
            prop="log_id"
            label="id"
            width="80">
        </el-table-column>
        <el-table-column
            prop="user_id"
            label="用户id"
            width="120">
        </el-table-column>
        <el-table-column
            prop="before_info"
            label="变更前"
            width="120">
        </el-table-column>
        <el-table-column
            prop="after_info"
            label="变更后"
            width="120">
        </el-table-column>
        <el-table-column
            prop="operate_type"
            :formatter="formatOperateType"
            label="变更类型"
            width="120">
        </el-table-column>
        <el-table-column
            prop="operate_time"
            label="变更时间"
            width="150">
        </el-table-column>
      </el-table>
      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="17"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryUserChange} from "@/api/request";

export default {
  name: "UserChangeTieList",
  data(){
    return {
      tableData:[],
      height: window.innerHeight - 240,
      currentIndex: 1,
      total: 0,
      queryField:{
        log_id: "",
        operate_user_id: "",
        operate_type: "",
      },
      operateTypeOptions:[
        {
          value: "",
          label: "变更类型"
        },
        {
          value: 1,
          label: "用户解绑手机"
        },
        {
          value: 5,
          label: "用户绑定手机"
        },
        {
          value: 10,
          label: "用户解绑微信"
        }
      ]
    }
  },
  mounted() {
    this.loadData(1);
  },
  methods: {
    loadData(index){
      let params = {
        pageNo: index,
        pageSize: 17,
        params: this.queryField
      }
      queryUserChange(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
      })
    },
    formatOperateType(row, column, cellValue){
      let ret = '';
      if(cellValue === 1){
        ret = "用户解绑手机";
      } else if(cellValue === 5){
        ret = "用户绑定手机";
      } else if(cellValue === 10){
        ret = "用户解绑微信";
      }
      return ret;
    }
  }
}
</script>

<style scoped>

</style>